import ProductCell from "./ProductCell";

export default class Product {
  sku;
  name;
  collection;
  description;
  features;
  cells;
  photoSet;
  configurable;
  soldOut;
  brandName;
  brandLogo;

  constructor(productWire, imageByNameLowerCase, shortNames) {
    this.sku = shortNames ? productWire.p_sk : productWire.product_dto_sku;
    this.name = shortNames ? productWire.p_nm : productWire.product_dto_name;
    this.collection = shortNames ? productWire.p_co : productWire.product_dto_collection;
    this.description = shortNames ? productWire.p_ds : productWire.product_dto_description;
    this.features = shortNames ? productWire.p_ft : productWire.product_dto_features;
    var dtoCells = shortNames ? productWire.p_cl : productWire.product_dto_cells;
    this.cells = Object.keys(dtoCells).reduce((total, key) => {
      var cellWire = dtoCells[key];
      total[key] = new ProductCell(cellWire, shortNames);
      return total;
    }, {});

    var dtoPhotoSet = shortNames ? productWire.p_ps : productWire.product_dto_photo_set;
    this.photoSet = {
      group:
        dtoPhotoSet.GroupPhoto ? imageByNameLowerCase[dtoPhotoSet.GroupPhoto.toLowerCase()] :
          imageByNameLowerCase["amptab_default.jpg"],
      individual:
        dtoPhotoSet.IndividualPhoto ? imageByNameLowerCase[dtoPhotoSet.IndividualPhoto.toLowerCase()] :
          imageByNameLowerCase["amptab_default.jpg"],
      all:
        dtoPhotoSet.ReallyAllPhotos.length == 0 ? [imageByNameLowerCase["amptab_default.jpg"]] :
          dtoPhotoSet.ReallyAllPhotos.map(name => imageByNameLowerCase[name.toLowerCase()])
    };

    this.configurable = shortNames ? productWire.p_cf : productWire.product_dto_configurable;
    this.soldOut = productWire.p_so;
    this.brandName = shortNames ? productWire.p_bn : productWire.product_dto_brand_name;
    var brandLogo = shortNames ? productWire.p_bl : productWire.product_dto_brand_logo;
    var brandLogoLower = brandLogo ? brandLogo.toLowerCase() : "";
    this.brandLogo = imageByNameLowerCase[brandLogoLower];
  }

  filter(columnIdToValuesLowerCase) {
    return Object.keys(columnIdToValuesLowerCase).every(id => {
      var valuesLowerCase = columnIdToValuesLowerCase[id];
      if (valuesLowerCase.length <= 0) {
        return true;
      }
      return this.cells[id].set.some(value => valuesLowerCase.includes(value.toLowerCase()));
    });
  }

  searchWeight(searchColumns, searchLowerCase) {
    var searchCells = searchColumns.map(column => ({ column: column, cell: this.cells[column.id] }));
    var matchCells = searchCells.filter(a => a.cell.display.toLowerCase().includes(searchLowerCase));
    var matchWeights = matchCells.map(a => a.column.searchWeight);
    var maxSearchWeight = Math.max(...matchWeights);

    return maxSearchWeight;
  }
}
